import { CALL_API, Schemas } from '../../common/middleware/api';

export const SELF_ASSESSMENTS_REQUEST = 'SELF_ASSESSMENTS_REQUEST';
export const SELF_ASSESSMENTS_SUCCESS = 'SELF_ASSESSMENTS_SUCCESS';
export const SELF_ASSESSMENTS_FAILURE = 'SELF_ASSESSMENTS_FAILURE';

export const SELF_ASSESSMENT_FETCH_REQUEST = 'SELF_ASSESSMENT_GET_REQUEST';
export const SELF_ASSESSMENT_FETCH_SUCCESS = 'SELF_ASSESSMENT_GET_SUCCESS';
export const SELF_ASSESSMENT_FETCH_FAILURE = 'SELF_ASSESSMENT_GET_FAILURE';

export const loadSelfAssessments = ({ childId, ...options }) => ({
    [CALL_API]: {
        types: [SELF_ASSESSMENTS_REQUEST, SELF_ASSESSMENTS_SUCCESS, SELF_ASSESSMENTS_FAILURE],
        endpoint: 'api/selfAssessmentFormResponses',
        request: { childId, ...options },
        schema: Schemas.SELF_ASSESSMENT_ARRAY
    },
    childId
});

export const fetchSelfAssessment = (id) => ({
    [CALL_API]: {
        types: [SELF_ASSESSMENT_FETCH_REQUEST, SELF_ASSESSMENT_FETCH_SUCCESS, SELF_ASSESSMENT_FETCH_FAILURE],
        endpoint: `api/selfAssessmentFormResponses/${id}`,
        schema: Schemas.SELF_ASSESSMENT
    }
});